/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldinstagram3Inputs */

const en_placewebfieldinstagram3 = /** @type {(inputs: Placewebfieldinstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const de_placewebfieldinstagram3 = /** @type {(inputs: Placewebfieldinstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Placewebfieldinstagram3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldinstagram3 = /** @type {((inputs?: Placewebfieldinstagram3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldinstagram3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldinstagram3(inputs)
	return de_placewebfieldinstagram3(inputs)
});
export { placewebfieldinstagram3 as "placeWebFieldInstagram" }